import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Panel from '@anwb/poncho/components/panel';
import { useGaFunnelInfo } from 'hooks/useGaFunnelInfo';
import { setDurationPeriod } from 'store/actions';
import { isFlexSelector } from 'store/selectors';
import { setCookie } from 'utils';
import { trackEvent } from 'utils/trackEvent';

import { DurationFull } from './DurationFull';
import { updatePricePointForDuration, useDefaultDuration } from './utils';

type DurationsProps = {
	confirmOnChange?: boolean;
	value?: string;
	onChange?: (value: string) => void;
};

export const Durations = ({ confirmOnChange = false, value, onChange }: DurationsProps) => {
	const {
		selectedDuration,
		availableDurations,
		cheapestDuration,
		groupedPricePoints,
		selectedKilometrage,
	} = useDefaultDuration();
	const isFlex = useSelector(isFlexSelector);

	const dispatch = useDispatch();
	const gaFunnelInfo = useGaFunnelInfo();

	const handleChange = useCallback(
		(newValue: string | string[], isSelect = false) => {
			if (typeof newValue === 'string' && selectedDuration !== newValue) {
				if (confirmOnChange && onChange) {
					onChange(newValue);
				} else {
					setCookie('duration', newValue);
					trackEvent({
						event: 'user_interaction',
						type: 'form',
						component: isSelect ? 'drop-down' : 'form-input-radiobutton',
						action: 'change',
						category: 'durations',
						variant: `${newValue}-maanden`,
						...gaFunnelInfo,
					});
					dispatch(setDurationPeriod(newValue));

					// Update price point ID and price when duration changes
					if (!confirmOnChange) {
						updatePricePointForDuration(
							dispatch,
							newValue,
							groupedPricePoints,
							selectedKilometrage
						);
					}
				}
			}
		},
		[
			selectedDuration,
			confirmOnChange,
			onChange,
			dispatch,
			gaFunnelInfo,
			groupedPricePoints,
			selectedKilometrage,
		]
	);

	return (
		<Panel data-test="durations" hasOuterSpacing={false}>
			<Panel.Header title="Looptijd" />
			<Panel.Content>
				<DurationFull
					key={selectedDuration}
					availableDurations={availableDurations}
					handleChange={handleChange}
					selectedValue={value || selectedDuration || cheapestDuration}
					isFlex={isFlex}
				/>
			</Panel.Content>
		</Panel>
	);
};
